import { Container, Row, Col } from "react-bootstrap";
import { useNavigate, NavLink } from "react-router-dom";
import { useTranslation, Trans } from 'react-i18next';
import MondelezLogo from '../assets/mondelez.svg';
import NHLPAlogo from '../assets/nhlpa-en.png';
import NHLPAlogo_fr from '../assets/nhlpa-fr.png';
import Cookie from '../assets/cookie.png';

export default function Footer(){
    const { t, i18n } = useTranslation();
    const navigate = useNavigate();

    return (
        <Container fluid as="footer" className="App-footer">
            <Row>
                <Col className="text-center mb-4">
                    <img src={Cookie} alt="Oreo Cookie" className="oreo-cookie" />
                </Col>
            </Row>
            <Row as="ul" className="footer-links justify-content-center">
                <Col as='li' className="col-12 text-center col-sm-auto">
                    <NavLink exact to="/rules">{t('footer.link1')}</NavLink>
                </Col>
                <Col as='li' className="col-12 text-center col-sm-auto">
                    <NavLink exact to="/privacy">{t('footer.link2')}</NavLink>
                </Col>
                <Col as='li' className="col-12 text-center col-sm-auto">
                    <a href={i18n.resolvedLanguage === "fr" ? "https://www.mondelezinternational.com/canada-french/quebec-privacy-officer/" : "https://www.mondelezinternational.com/canada/quebec-privacy-officer/"}
                        target="_blank" rel="noopener noreferrer">
                                {t('footer.link3')}  
                    </a>
                </Col>
                <Col as='li' className="col-12 text-center col-sm-auto">
                    <NavLink exact to="/cookies">{t('footer.link6')}</NavLink>
                </Col>
                <Col as='li' className="col-12 text-center col-sm-auto">
                    <NavLink exact to="/terms">{t('footer.link4')}</NavLink>
                </Col>
                <Col as='li' className="col-12 text-center col-sm-auto">
                    <a href={i18n.resolvedLanguage === "fr" ? "https://www.mondelezinternational.com/-/media/Mondelez/Country/Canada/French/Accessibility_Plan_and_Policies_for_Mondelez_Canada.pdf" : "https://www.mondelezinternational.com/-/media/Mondelez/Country/Canada/Accessibility_Plan_and_Policies_for_Mondelez_Canada.pdf"}
                        target="_blank" rel="noopener noreferrer">
                                {t('footer.link5')}  
                    </a>
                </Col>
            </Row>

            <Row>
                <Col className="text-center d-flex justify-content-center mt-3 mb-5 align-items-center">
                    <img src={MondelezLogo} alt="Mondelez Logo" className="mondelez-logo" />
                    <img src={i18n.resolvedLanguage === "fr" ? NHLPAlogo_fr : NHLPAlogo} alt="NHLPA Logo" className="nhlpa-logo" />
                </Col>
            </Row>

            <Row className="skinny-row">
                <Col as="small">
                    {t('footer.sponsor')}
                </Col>
            </Row>

        </Container>
    );
}